/* tslint:disable */
/* eslint-disable */
/**
 * Venue Loyalty API
 * Onyx Gaming Venue Loyalty API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';
import type { SearchPlayerMobile200ResponseResults } from './SearchPlayerMobile200ResponseResults';
import {
    SearchPlayerMobile200ResponseResultsFromJSON,
    SearchPlayerMobile200ResponseResultsFromJSONTyped,
    SearchPlayerMobile200ResponseResultsToJSON,
    instanceOfSearchPlayerMobile200ResponseResults,
} from './SearchPlayerMobile200ResponseResults';

/**
 * 
 * @export
 * @interface SearchPlayerMobile200Response
 */
export interface SearchPlayerMobile200Response {
    /**
     * 
     * @type {SearchPlayerMobile200ResponseResults}
     * @memberof SearchPlayerMobile200Response
     */
    results?: SearchPlayerMobile200ResponseResults;
}


/**
 * Check if a given object implements the SearchPlayerMobile200Response interface.
 */
export function instanceOfSearchPlayerMobile200Response(value: object): boolean {
    let isInstance = true;
    return isInstance;
}

export function SearchPlayerMobile200ResponseFromJSON(json: any): SearchPlayerMobile200Response {
    return SearchPlayerMobile200ResponseFromJSONTyped(json, false);
}

export function SearchPlayerMobile200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchPlayerMobile200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'results': !exists(json, 'results') ? undefined : SearchPlayerMobile200ResponseResultsFromJSON(json['results']),
    };
}

export function SearchPlayerMobile200ResponseToJSON(value?: SearchPlayerMobile200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'results': SearchPlayerMobile200ResponseResultsToJSON(value.results),
    };
}

